import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import HeaderBar from 'screens/HeaderBar'
import Footer from 'screens/Footer'
import SideBar from 'screens/SideBar'
import Selector from 'screens/Selector'
import ViewTitle from 'screens/ViewTitle'
import { URLMap } from 'Menu'
import Logout from 'auth/Logout'
import CallDetail from 'screens/calls/list/CallDetail'
import CallLadder from 'screens/calls/list/Ladder'
import Drilldown from 'highcharts/modules/drilldown'
import Highcharts from 'highcharts'
import { translate } from 'react-i18next'
import { Segment, Sidebar, Responsive } from 'semantic-ui-react'
import { ErrorWrapper } from 'components/ErrorCatcher'
import { STAGE } from 'Constants'

class MainPage extends Component {

  // initialize the highcharts modules in a single location and get data period set
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: window.innerWidth > 1080,
      currentWidth: window.innerWidth
    };

    Drilldown(Highcharts);
  }

  handleHideClick = () => {
    this.setState({menuOpen: false});
  };

  handleShowClick = () => {
    this.setState({menuOpen: true});
  };

  windowResized = (event, data) =>  {
    if (data.width <= 1080 && this.state.currentWidth > 1080 && this.state.menuOpen) {
      this.handleHideClick();
    } else if (data.width > 1080 && this.state.currentWidth <= 1080 && !this.state.menuOpen) {
      this.handleShowClick();
    }
    this.setState({currentWidth: data.width});
  };

  // Render
  render() {
    let myPath = this.props.location.pathname.replace(this.props.location.search,'');
    let toggleMenu = this.state.menuOpen ? this.handleHideClick : this.handleShowClick;

    return (
      <div>
        <Responsive onUpdate={this.windowResized} />
        <HeaderBar {...this.props} menuToggle={toggleMenu}/>
        <Sidebar.Pushable className="main">
          <SideBar {...this.props} menuVisible={this.state.menuOpen}/>

          <Sidebar.Pusher>
            <Segment basic className="main-content">
              <div id="content-wrapper">
                <Selector {...this.props} doRender={URLMap.hasOwnProperty(myPath) && URLMap[myPath].isSelector} />
                <ViewTitle title={URLMap.hasOwnProperty(myPath) ? 
                  URLMap[myPath].titles : null } 
                />

                <Switch>
                  <Route
                    exact path={"/calls/list/callDetail"}
                    component={ErrorWrapper(CallDetail)}
                  />
                  { STAGE === "dev" && 
                  <Route
                    exact path={"/calls/list/callLadder"}
                    component={ErrorWrapper(CallLadder)}
                  />
                  }
                  <Route
                    exact path={"/logout"}
                    component={ErrorWrapper(Logout)}
                  />
                  {Object.values(URLMap).map((entry, index) => {
                      return (<Route
                                exact path={entry.url}
                                component={ErrorWrapper(entry.app)}
                                key={index}
                              />
                             )
                  })}
                </Switch>
              </div>
              <Footer/>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default translate()(MainPage);
